//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import vueI18n from '@/vueI18n'
import { i18n } from '@/vueI18n';
import moment from 'moment';

import { GuideModel } from '@/modules/guide/guide-model';
const { fields } = GuideModel;

export default {
  name: 'app-view-guide',
  props: {
    value: {
      type: Object,
      required: true,
    }, 
    details: {
      type: Object,
      required: false,
    },
  },

  mounted() {
    console.log('details', this.details);
    this.tab = this.isUpdated ? 'updated-version' : undefined
  },

  data() {
    return {
      dialog: false,
      tab: undefined,
      acceptLoading: false, 
      ignoreLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      findLoading:'notification/form/findLoading',
      saveLoading: 'notification/form/saveLoading',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    dialogVisible: {
      get: function () {
        return this.visible;
      },

      set: function (value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    fields() {
      return fields;
    },
    language() {
      return vueI18n.locale
    },
    avatar() {
      if (this.isThisFieldUpdated('avatar')) {
        return this.value.updates && this.value.updates.avatar ? this.value.updates.avatar.publicUrl : '/images/icons/ic-notification-read.svg'
      } else {
        // console.log(this);
        return this.details.avatar ? this.details.avatar.publicUrl : '/images/icons/ic-notification-read.svg'
      }
    },
    license() {
      if (this.isThisFieldUpdated('license')) {
        return this.value.updates && this.value.updates.license ? this.value.updates.license.publicUrl : null
      } else {
        return this.details && this.details.license ? this.details.license.publicUrl : null
      }
    },
    gender() {
      if (this.isThisFieldUpdated('isMale')) {
        return this.value.updates && this.value.updates.isMale ? this.i18n('common.male') : this.i18n('common.female')
      } else {
        return this.details && this.details.isMale ? this.i18n('common.male') : this.i18n('common.female')
      }
    },
    languages() {
      if (this.isThisFieldUpdated('languages')) {
        return this.value.updates && this.value.updates.languages.length ? this.value.updates.languages.join(", ") : null
      } else {
        return this.details && this.details.isMale ? this.details.languages.join(", ") : null
      }
    },
    isUpdated() {
      return this.value.type.includes('Update')
    },
    isThisFieldUpdated() {
      return (fieldName) => { 
        return this.tab == 'updated-version' && (fieldName in this.value.updates) 
      }
    },
  },

  methods: {
    i18n(code, args) {
      return i18n(code, args);
    },
    doClose() {
      this.$emit('close')
    },
    doAccept() { 
      this.acceptLoading = true
      this.$emit('accept'); 
      setTimeout(() => {
        this.acceptLoading = false
        this.$emit('close')
      }, 1000);
    },
    doReject() { 
      // this.rejectLoading = true
      this.$emit('reject'); 
        this.$emit('close')
      // setTimeout(() => {
      //   this.rejectLoading = false
      // }, 1000);
    },
    presenter(row, fieldName) {
      const val = GuideModel.presenter(row, fieldName);
      return val ? val : 'ـــ';
    },
    presenterDetails(details, fieldName) {
      const val = details && details[fieldName] ? GuideModel.presenter(details, fieldName) : null;
      // return val ? val : 'ـــ';
      return val ? val : '.................................'
    },
    presenterEnum(row, fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == row[fieldName])
      return val.length ? val[0].label : 'ـــ';
    },
    presenterMap(row, fieldName) {
      const val = GuideModel.presenter(row, fieldName);
      return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(val) {
      // const val = GuideModel.presenter(row, fieldName);
      return val ? moment(val).locale(this.currentLanguageCode).format("DD-MM-YYYY h:mm A") : 'ـــ'; 
    },
    presenterDate(val) {
      // const val = GuideModel.presenter(row, fieldName)
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMMM, YYYY") : 'ـــ'; 
    },
    presenterDay(row, fieldName) {
      return moment(GuideModel.presenter(row, fieldName)).locale(this.currentLanguageCode).format("dddd");
    },
    presenterTime(row, fieldName) {
      // let now = moment().locale('en').format('YYYY/MM/DD');
      // let time = GuideModel.presenter(row, fieldName)
      let n = row[fieldName]

      // console.log();
      // let date =  `${now} ${time}`;
      return moment(n,"YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm a')
    },
    presenterStore(row, fieldName, key) {
      const user = GuideModel.presenter(row, fieldName);
      if (key == 'avatars' || key == 'avatar') {
        let avatar = null
        if (user && Array.isArray(user[key])) {
          avatar = user[key].length ? user[key][0].publicUrl : null
        } else if (user && user[key]) {
          avatar = user[key].publicUrl 
        }
        return avatar ? avatar : 'https://firebasestorage.googleapis.com/v0/b/puricom-beebe.appspot.com/o/public%2Fdefault%2Favatar.svg?alt=media&token=439fb6e6-815f-453e-9e3a-79dc0ab3d40c'
      }
      return user && user[key] ? user[key] : 'ـــ'; 
    },
    presenterClient(row, fieldName, key) {
      const val = GuideModel.presenter(row, fieldName);
      return val && val[key] ? val[key] : 'ـــ'; 
    },
    presenterLocalization(data) {
      if (typeof data === 'object' && data !== null) {
        return data[this.currentLanguageCode] ? data[this.currentLanguageCode] : data['en']
        // if (this.currentLanguageCode in data) {
        //   return data[this.currentLanguageCode]
        // }
      }
      return  
    },
    // async doSubmit() {
    //   await this.$emit('submit', this.id)
    // },
  },
};
